import { Card, CardContent } from 'framework7-react';

interface EmptyStateProps {
  icon: string;
  iconColor?: string;
  title: string;
  description?: string;
}

function EmptyState({ icon, iconColor = '#c7c7cc', title, description }: EmptyStateProps) {
  return (
    <Card>
      <CardContent>
        <div style={{ textAlign: 'center' }}>
          <div
            style={{
              width: 80,
              height: 80,
              backgroundColor: '#f2f2f7',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px',
            }}
          >
            <i className="f7-icons" style={{ fontSize: 36, color: iconColor }}>
              {icon}
            </i>
          </div>
          <h3 style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}>{title}</h3>
          {description && <p style={{ fontSize: 15, color: '#8e8e93' }}>{description}</p>}
        </div>
      </CardContent>
    </Card>
  );
}

export default EmptyState;
